<template>
  <div
    class="modal fade createNewModal"
    id="AddTypeDemandeModal"
    tabindex="-1"
    aria-hidden="true"
    ref="addTypeDemandeModalRef"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="typeDemandeForm" @submit="addTypeDemande" :validation-schema="typeDemandeSchema">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Service <span class="text-danger">*</span>
                </label>
                <Field  name="service" v-slot="{ field }">
                  <Multiselect 
                      v-model="field.value"
                      v-bind="field"
                      :options="serviceOptions"
                      placeholder="Sélectionner un service"/>
                </Field>
                <ErrorMessage name="service" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type notification<span class="text-danger">*</span>
                  </label>
                  <Field name="typeNotification" v-slot="{ field }">
                    <Multiselect :options="typeNotificationOptions" :searchable="true" v-model="field.value"
                      v-bind="field" placeholder="Sélectionner un type de notification" />
                  </Field>
                  <ErrorMessage name="typeNotification" class="text-danger" />
                </div>
              </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Code <span class="text-danger">*</span>
                </label>
                <Field name="code" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le code"/>
                <ErrorMessage name="code" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Libelle <span class="text-danger">*</span>
                </label>
                <Field name="libelle" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libellé"/>
                <ErrorMessage name="libelle" class="text-danger"/>
              </div>
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import { error, hideModal, success } from '@/utils/utils';
import { TypeDemande } from '@/models/TypeDemande';
import Multiselect from '@vueform/multiselect';
import axios from 'axios';

export default {
  name: "AddTypeDemandeModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  props: {
    item: {
      type: Number,
      required: true
    }
  },
  setup(props,{ emit }) {
    const typeDemandeSchema = Yup.object().shape({
      libelle: Yup.string().required('Le libellé est obligatoire'),
      service: Yup.string().required('Le service est obligatoire'),
      typeNotification: Yup.string().required('Le type de notification est obligatoire'),
      code: Yup.string().required('Le code est obligatoire').max(5, "Vous ne devez pas dépasser cinq caractères"),
    });

    const typeDemandeForm = ref<TypeDemande | null>(null);
    const router = useRouter();
    const addTypeDemandeModalRef = ref<null | HTMLElement>(null);
    const serviceOptions = ref([]);
    const isUPDATE = ref<boolean>(false);
    const title = ref('Ajouter un type de demande');
    const btntext = ref('Ajouter');
    const typeNotificationOptions = ref<Array<any>>([]);
    const typeNotification = ref("");

    watch(() => props.item , (newValue) => {
      if (newValue!=0) {
        getTypeDemande(newValue);
        isUPDATE.value = true;
        btnTitle();
      }
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier un type de demande";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter un type de demande";
         btntext.value = "Ajouter";
      }
    }
    const getTypeNotification = async () => {
      try{
        typeNotificationOptions.value = [];
        const response = await axios.get("/typeNotifications");
              
        const donnees = response.data.data;
        console.log("ZZZZZZZ ===> ",donnees); 
        typeNotificationOptions.value = donnees.map((item: any) => {
          return {
            label: item.libelle,
            value: item.id,
          };
        });
      }catch(error) {
        //error(error.message);
      }
    }

    const getTypeDemande = async (id: number) => {
      return ApiService.get("/typeDemandes/"+id)
      .then(({ data }) => {
        //yup display data in form with modePaiementSchema
        for (const key in data.data) {
          typeDemandeForm.value?.setFieldValue(key,
          (typeof data.data[key] === 'object' && data.data[key] !== null) ? data.data[key].id : data.data[key]);
        }
        emit('openmodal', addTypeDemandeModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message);
      });
    }

    const fetchService = async () => {
      return ApiService.get("/services")
      .then(({ data }) => {
        const donnee = data.data;
        serviceOptions.value = donnee.map((item: any) => {
          return {
            label: item.libelle,
            value: item.id,
          };
        });
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    const addTypeDemande = async (values: any ,typeDemandeForm) => {
      
      values = values as TypeDemande;
      if(isUPDATE.value){
        ApiService.put("/typedemandes/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              typeDemandeForm.resetForm();
              hideModal(addTypeDemandeModalRef.value);
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        ApiService.post("/typedemandes",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              typeDemandeForm.resetForm();
              hideModal(addTypeDemandeModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
      
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
        formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    onMounted(async () => {
      await fetchService();
      await getTypeNotification();
    });

    return { typeDemandeSchema,typeNotificationOptions,typeNotification, addTypeDemande, typeDemandeForm, addTypeDemandeModalRef, serviceOptions,
      btntext,title,resetValue  };
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>